import {
  createPlugin,
  createRoutableExtension,
} from '@backstage/core-plugin-api';

import { rootRouteRef } from './routes';

export const releaseControlPlugin = createPlugin({
  id: 'release-control',
  routes: {
    root: rootRouteRef,
  },
});

export const ReleaseControlPage = releaseControlPlugin.provide(
  createRoutableExtension({
    name: 'ReleaseControlPage',
    component: () =>
      import('./components/ReleaseControlTabComponent').then(m => m.ReleaseControlTabComponent),
    mountPoint: rootRouteRef,
  }),
);
